const DAYS_IN_MONTH = (month) => {
  if (!month) return 31;
  if ([4, 6, 9, 11].includes(month)) return 30;
  if (month === 2) return 29; // allow Feb 29
  return 31;
};

const MONTH_NAMES = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export function monthDayToKey(month, day) {
  if (!month || !day) return "";
  const mm = String(month).padStart(2, "0");
  const dd = String(day).padStart(2, "0");
  return `${mm}-${dd}`;
}

export function parseFeastKey(key) {
  if (!key) return null;
  const s = String(key).trim();
  if (!/^\d{2}-\d{2}$/.test(s)) return null;
  const m = Number(s.slice(0, 2));
  const d = Number(s.slice(3, 5));
  if (!m || !d) return null;
  if (m < 1 || m > 12) return null;
  if (d < 1 || d > DAYS_IN_MONTH(m)) return null;
  return { month: m, day: d, key: monthDayToKey(m, d) };
}

export function formatFeastDMMMM(feast) {
  if (!feast) return "";
  const m = Number(feast.month);
  const d = Number(feast.day);
  if (!m || !d || m < 1 || m > 12) return "";
  return `${d} ${MONTH_NAMES[m - 1]}`;
}

export function feastSummary(s) {
  const keys = Array.isArray(s?.feastKeys)
    ? s.feastKeys
    : s?.feastKey
    ? [s.feastKey]
    : [];

  const parsed = keys.map(parseFeastKey).filter(Boolean);
  if (!parsed.length) return "";

  const shown = parsed
    .slice(0, 2)
    .map((f) => formatFeastDMMMM(f))
    .filter(Boolean)
    .join(", ");

  const more = parsed.length > 2 ? ` +${parsed.length - 2}` : "";
  return shown ? ` • Feast${parsed.length >= 2 ? "s" : ""}: ${shown}${more}` : "";
}
